import { Clock, Users } from "lucide-react";

export function MealDisplayFront({ recipe }) {
  const mealTags =
    recipe.mealTagList.length > 0
      ? recipe.mealTagList.map((tag) => tag.tagContent)
      : ["All"];
  return (
    <div
      className="absolute w-full h-full bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow"
      style={{
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
      }}
    >
      <div className="h-48 bg-gradient-to-br from-orange-400 to-pink-500 group-hover:scale-105 transition-transform" />

      <div className="p-4 flex flex-col h-[calc(100%-12rem)]">
        <h3 className="font-medium text-gray-900 mb-3">{recipe.mealName}</h3>

        {/* 4-corner layout */}
        <div className="grid grid-cols-2 grid-rows-2 flex-1 text-xs text-gray-600">
          {/* Top Left - Time */}
          <div className="flex items-start gap-1">
            <Clock className="w-3.5 h-3.5" />
            <span>{recipe.timeMins ?? 30} min</span>
          </div>

          {/* Top Right - Servings */}
          <div className="flex items-start justify-end gap-1 text-right">
            <Users className="w-3.5 h-3.5" />
            <span>{recipe.servings ?? 2}</span>
          </div>

          {/* Bottom Left - Meal Tags */}
          <div className="flex items-end gap-1 flex-wrap">
            {mealTags.map((tagContent, idx) => (
              <span
                key={idx}
                className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded"
              >
                {tagContent}
              </span>
            ))}
          </div>

          {/* Bottom Right - Rating */}
          <div className="flex items-end justify-end gap-1">
            {/* <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            <span className="text-sm font-medium text-gray-900">
              {recipe.rating ?? 4}
            </span> */}
          </div>
        </div>
      </div>
    </div>
  );
}
